import { BrowserRouter , Route, Routes } from "react-router-dom";
import Profile from './Components/Profile'
import Ticket from './Components/Ticket'
import Signin from './Components/UnAuthenticated/Signin'
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
    <Routes>
    <Route path ="/" element={<Signin/>} />
    <Route path ="/signin" element={<Signin/>} />
    <Route path ="/ticket" element={<Ticket/>} />
    <Route path ="/profile" element={<Profile/>} /> 
    </Routes>
  </BrowserRouter>
    </div>
  );
}

export default App;
